<template lang="html">
  <div class="mymessage">
<transition name="move">
          <div class="testclass" v-show="showFlag" >
            <div class="overview" >
                <div class="overview-left">
                    <div class="avatar">
                      <img v-if="this.$store.state.uuid!=null" v-bind:src="$store.state.myinfo.avatar" alt="">
                      <img v-else v-bind:src="state.avatarvip" alt="">
                    </div>
                    <!-- <p v-if="this.$store.state.uuid!=null" class="title">{{$store.state.myinfo.name}}</p> -->
                </div>
                <div class="overview-right">
                    <div v-if="this.$store.state.uuid!=null" class="score-wrapper">
                      <div class="title-father"  @click="modifymyinfo()">
                         <div class="title">{{$store.state.myinfo.description}}</div>
                      </div>
                        <span class="score">{{$store.state.myinfo.username}}</span>
                    </div>
                    <div v-else class="score-wrapper">
                      <!-- 未登录 -->
                        <div class="title-father"><div class="title">{{ $t('notsignin') }}</div></div>
                    </div>
                </div>
            </div>
            <split></split>
            <div v-if="this.$store.state.uuid!=null" class="rating-type">
                <div class="img-wrapper"  @click="selectFood('待收货')">
                    <img :src="require('./serving.png')" alt="">   
                    <!-- 待收货 -->
                    <p>{{ $t('pending') }}</p>
                </div>
                  <div class="img-wrapper"  @click="selectFood('完成')">
                    <img :src="require('./finished.png')" alt="">
                  <!-- 完成 -->
                  <p>{{ $t('complete') }}</p>
                </div>
            </div>
            <!-- <div class="switch">
              <span class="icon icon-check_circle"></span>
              <span class="text">只看内容的评价</span>
            </div> -->
            <div class="list-content" ref="listContent">
                <ul>
                    <li v-if="this.$store.state.uuid!=null" class="mymessagefood"  @click="selectFood('我的地址')">
                        <!-- 我的地址 -->
                        <div class="name">{{ $t('myaddress') }}</div>
                        <div class="cartcontrol-wrapper">
                            <img src="https://api.freepos.es/files/sample/default_header.png" alt="">
                        </div>
                    </li>
                    <li class="mymessagefood" @click="selectFood('客服电话')">
                        <!-- 客服电话 -->
                        <div class="name">{{ $t('customerservice') }}</div>

                        <div class="cartcontrol-wrapper">
                            <img src="https://api.freepos.es/files/sample/default_header.png" alt="">
                        </div>
                    </li>
                    <li class="mymessagefood" @click="selectFood('在线客服')">
                        <!-- 在线客服 -->
                        <div class="name">{{ $t('onlineservice') }}</div>

                        <div class="cartcontrol-wrapper">
                            <img src="https://api.freepos.es/files/sample/default_header.png" alt="">
                        </div>
                    </li>
                    <li class="mymessagefood">
                        <!-- 当前语言 -->
                        <div class="name">{{ $t('language') }}</div>
                        <div class="locale-changer">
                          <el-select v-model="$i18n.locale" placeholder="Language">
                            <el-option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang" :label="langsname[i]"></el-option>
                          </el-select>
                        </div>
                    </li>
                    <li class="mymessagefood2" @click="singinAndsingout()">
                      <div v-if="this.$store.state.uuid!=null" class="cartcontrol-wrapper2">
                        {{$t('signout')}}
                      </div>
                      <div v-else class="cartcontrol-wrapper-login">
                        {{$t('signin')}}
                      </div>
                    </li>
                </ul>
            </div> 
          </div>
</transition>
    <returnbutton  ref="returnbutton"></returnbutton>
    <myaddress ref="myaddress"></myaddress>
    <orders ref="orders"></orders>

  </div>
</template>

<script>
import split from 'components/split/split2.vue'
import myaddress from 'components/myaddress/myaddress.vue'
import orders from 'components/orders/orders.vue'
import returnbutton from 'components/mymessage/returnbutton.vue'
import eventbus from '../../common/js/eventbus.js'
import {Encrypt} from 'common/js/secret.js'

export default {
  name: 'locale-changer',
  props: {},
  data() {
    return {
      showFlag: true,
      langs: ['es', 'en', 'cn'],
      langsname: ['Español', 'English', '中文'],
      str: '',
      state: this.$store.state
    }
  },
  created() {
    this.refresh()
  },
  // updated() {
  //   this.refresh()
  // },
  methods: {
    show() {
      this.showFlag = true
    },
    linkDownload (url) {
      window.open(url, '_blank') // 新窗口打开外链接
    },
    telphone (tel) {
      location.href = 'tel:' + tel // 新窗口打开外链接
      this.state.dev = !this.state.dev
    },
    selectFood(data) {
      this.str = data
      if (data === '我的地址') {
        this.$refs.returnbutton.show()
        this.$refs.myaddress.show()
        this.showFlag = false
      } else if (data === '客服电话') {
        this.telphone(this.$store.state.seller.customerService)
      } else if (data === '在线客服') {
        this.linkDownload(this.$store.state.seller.onlineService)
      } else if (data === '待收货') {
        this.$refs.orders.show('待收货')
        this.$refs.returnbutton.show()
        this.showFlag = false
      } else if (data === '完成') {
        this.$refs.returnbutton.show()
        this.$refs.orders.show()
        this.showFlag = false
      }
    },
    refresh() {
      // 刷新我的信息
      if (this.$store.state.dev) console.log('我的信息页面刷新', this.state.myinfo.description)
      if (this.state.myinfo !== null && this.state.myinfo.openId !== 'undefined' && this.state.myinfo.openId !== '') {
        this.$http.get(this.api.getUser + '?openId=' + encodeURIComponent(Encrypt(this.state.myinfo.openId || '')) + '&hash=' + encodeURIComponent(this.state.myinfo.hash || '') + '&SellerID=' + (this.state.myinfo.SellerID || 1) + this.state.ibnumber)
        .then((res) => {
          this.state.myinfo = res.data.data[0]
          this.state.uuid = this.state.myinfo.openId
        })
        .catch(err => {
          console.log(`登录失败${err}`)
        })
      }
    },
    singinAndsingout() {
      if (this.$store.state.uuid !== null) {
        this.state.uid = null
        this.state.uuid = null
        this.state.defaultaddress = 0
        this.state.myinfo = {
          ID: null,
          SellerID: 1,
          openId: '',
          name: '',
          hash: '',
          addres: []
        }
        this.$store.dispatch('saveinfo', this.state)
        if (this.$store.state.dev) console.log('注销', this.state.myinfo)
        this.refresh()
      } else {
        this.$router.push('/login')
      }
    },
    contentclick() {
      let id = this.$store.state.uuid
      if (id === null && this.contentstr !== '返回') {
        this.singin()
      } else if (id != null && this.contentstr !== '返回') {
        this.singinAndsingout()
      } else if (this.contentstr === '返回') {
        this.hide(this.str)
      }
    },
    changelanguage() {
      if (this.$store.state.dev) console.log('切换语言', this.state.myinfo)
      this.$store.state.i18n = this.$i18n.locale
      this.$store.dispatch('saveinfo', this.state)
    },
    modifymyinfo() {
      this.$router.push('/modifymyinfo')
    }
  },
  mounted() {
    eventbus
      .$on('refresh_myinfo', item => {
        if (this.$store.state.dev) console.log('接收', this.state.myinfo.description)
        this.state.myinfo = item
      })
      .$on('open_myaddress', item => {
        if (this.$store.state.dev) console.log('接收open_myaddress', item)
        this.selectFood('我的地址')
      })
  },
  beforeDestroy () {
    eventbus.$off('refresh_myinfo').$off('open_myaddress')
  },
  computed: {
    // 监听语言改变,由于不能直接监听对象,所以要用computed实现
    i18nlocale() {
      return this.$i18n.locale
    }
  },
  watch: {
    // 监听语言改变,由于不能直接监听对象,所以要用computed实现
    i18nlocale(val) {
      localStorage.setItem('locale', this.$i18n.locale)
      // this.changelanguage()
    }
  },
  filters: {
  },
  components: {
    split,
    myaddress,
    orders,
    returnbutton
  }
}
</script>

<style lang="scss">
@import '../../common/sass/mixin.scss';

.mymessage {
    position: fixed;
    top: 174px;
    @media only screen and (max-width: 320px) {
        top: 136px;
    }
    bottom: 0px;
    left: 0;
    width: 100%;
    //z-index:10;
    // overflow-y: auto;
    // overflow-x: hidden;
    // -webkit-overflow-scrolling: touch;
    .testclass {
        position: absolute;
        overflow-y: auto;
        overflow-x: hidden;
        -webkit-overflow-scrolling: touch;
        top: 0px;
        bottom: 0px;
        left: 0;
        // width: 100%;
        right: -5px;
        &.move-enter-active,
        &.move-leave-active {
            // 动画过程
            transition: all 0.5s;
            transform: translate3d(0, 0, 0);
        }
        &.move-enter,
        &.move-leave-to {
            // 动画初始态
            transform: translate3d(100%, 0, 0);
        }
        .overview {
            max-height: 110px;
            overflow: hidden;
            display: flex;
            padding: 18px 0;
            .overview-left {
                flex: 0 0 137px;
                width: 137px;
                border-right: 1px solid rgba(7, 17, 27, 0.1);
                text-align: center;
                @media only screen and (max-width: 320px) {
                    flex: 0 0 120px;
                    width: 120px;
                }
                .title {
                    margin: 8px 0px;
                    line-height: 12px;
                    font-size: 12px;
                    color: rgb(7, 17, 27);
                }
                .avatar {
                    flex: 0 0 28px;
                    width: 80px;
                    height: 80px;
                    margin: auto;
                    border-radius: 50%;
                    overflow: hidden;
                    img {
                        width: 100%;
                    }
                }
            }
            .overview-right {
                flex: 1;
                padding: 6px 10px 6px 24px;
                @media only screen and (max-width: 320px) {
                    padding-left: 6px;
                }
                .score-wrapper {
                    margin-bottom: 8px;
                    font-size: 0;
                    .title-father {
                        overflow: hidden;
                        width: 100%;
                        -webkit-overflow-scrolling: touch;
                        .title {
                            word-wrap: break-word;
                            white-space: pre-wrap;
                            white-space: -moz-pre-wrap;
                            max-height: 80px;
                            width: 105%;
                            overflow-y: auto;
                            overflow-x: hidden;
                            -webkit-overflow-scrolling: touch;
                            display: inline-block;
                            vertical-align: top;
                            line-height: 18px;
                            font-size: 12px;
                            color: rgb(7, 17, 27);
                        }
                    }
                    .score {
                        display: inline-block;
                        line-height: 18px;
                        vertical-align: top;
                        font-size: 12px;
                        color: rgb(255, 153, 0);
                    }
                }
            }
        }

        .rating-type {
            display: flex;
            padding: 10px 0px;
            justify-content: space-around;
            font-size: 12px;
            @include border-1px(rgba(7, 17, 27, 0.1));
            margin: auto;
            .img-wrapper {
                text-align: center;
                width: 48px;
                img {
                    width: 40px;
                    height: 40px;
                }
            }
        }
        .list-content {
            overflow: hidden;
            background: #fff;
            // padding: 0 18px;
            .mymessagefood {
                position: relative;
                padding: 12px 0;
                box-sizing: border-box;
                @include border-1px(rgba(7, 17, 27, 0.1));
                height: 48px;
                .name {
                    line-height: 24px;
                    font-size: 14px;
                    color: rgb(7, 17, 27);
                    width: 70%;
                    margin-left: 10px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
                .cartcontrol-wrapper {
                    position: absolute;
                    right: 26px;
                    bottom: 12px;
                    width: 25px;
                    height: 25px;
                    img {
                        width: 100%;
                    }
                }

                .locale-changer {
                    position: absolute;
                    right: 26px;
                    bottom: 5px;
                    width: 145px;
                }
            }
            .mymessagefood2 {
                position: relative;
                box-sizing: border-box;
                @include border-1px(rgba(7, 17, 27, 0.1));
                padding: 10px 0px;
                .cartcontrol-wrapper2 {
                    border-radius: 5px;
                    width: 70%;
                    height: 40px;
                    background-color: red;
                    margin: auto;
                    text-align: center;
                    line-height: 40px;
                    color: #fff;
                }
                .cartcontrol-wrapper-login {
                    border-radius: 5px;
                    width: 70%;
                    height: 40px;
                    background: #00b43c;
                    margin: auto;
                    text-align: center;
                    line-height: 40px;
                    color: #fff;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// mymessage.vue?4f66a708